// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"cc88f4a8","268":"855e0b6e","339":"9080e0d6","454":"63138554","460":"a08b6581","867":"80fe0dfa","871":"7aff593a","986":"bc96ebd7"}[chunkId] + ".chunk.js";
};